import { useDroppable } from "@dnd-kit/core";

type Props = {
  id: number;
  children: React.ReactNode;
};
function Droppable(props: Props) {
  const { setNodeRef } = useDroppable({
    id: props.id,
  });
  return (
    <div className="touch-device:p-6" ref={setNodeRef}>
      {props.children}
    </div>
  );
}

export default Droppable;
